import { render } from "./q10.vue?vue&type=template&id=109a9f6e&scoped=true"
import script from "./q10.vue?vue&type=script&lang=js"
export * from "./q10.vue?vue&type=script&lang=js"

import "./q10.vue?vue&type=style&index=0&id=109a9f6e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109a9f6e"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q10.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "109a9f6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('109a9f6e', __exports__)) {
    api.reload('109a9f6e', __exports__)
  }
  
  module.hot.accept("./q10.vue?vue&type=template&id=109a9f6e&scoped=true", () => {
    api.rerender('109a9f6e', render)
  })

}


export default __exports__